module.exports = __webpack_public_path__ + "static/media/baug_1.50238cbe.png";